import {createGlobalContext} from '@acng/frontend-relativity';

/**
 * @typedef {import('../model/session').LivecamSession} LivecamSession
 */

const MODULE = 'livecam/context/session';

/**
 * For now the currently running livecam show is provided without state information.
 * @todo Provide information about state changes.
 * @module
 */

/**
 * Observe the current livecam show.
 */
export const ctxLivecamSession = createGlobalContext(
  /**
   * @type {LivecamSession | null}
   */
  (null)
);

/**
 * Set the current livecam show.
 *
 * @param {LivecamSession | null} session
 */
export const setGlobalLivecamSession = (session) => {
  DEBUG: console.info(`${MODULE} provide`, {session});
  ctxLivecamSession.provide(null, session);
};
